import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/web/', //本地测试请开启
  routes: [
    {
      path: '/index',
      component: resolve => require(['@/website/pages/index'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        hideHeader: true
      },
      component: resolve => require(['@/website/pages/login'], resolve)
    },
    {
      path: '/detail',
      name: 'detail',
      component: resolve => require(['@/website/pages/detail'], resolve)
    },
    {
      path: '/download',
      name: 'download',
      component: resolve => require(['@/website/pages/download'], resolve)
    },
    {
      path: '/brand-news',
      name: 'brand-news',
      component: resolve => require(['@/website/pages/brand-news'], resolve)
    },
    {
      path: '/brand-news/detail',
      name: 'brand-news-detail',
      component: resolve =>
        require(['@/website/pages/brand-news-detail'], resolve)
    },
    {
      path: '/touge/order',
      name: 'tougeOrder',
      meta: {
        hideHeader: true
      },
      component: resolve => require(['@/website/pages/touge/order'], resolve)
    },
    {
      path: '/touge/pay',
      name: 'tougePay',
      meta: {
        hideHeader: true
      },
      component: resolve => require(['@/website/pages/touge/pay'], resolve)
    },
    {
      path: '/touge/privacy',
      name: 'tougePrivacy',
      meta: {
        hideHeader: true
      },
      component: resolve => require(['@/website/pages/touge/privacy'], resolve)
    },
    {
      path: '*',
      component: resolve => require(['@/website/pages/index'], resolve)
    }
  ]
})
